import { render, staticRenderFns } from "./BasePrimaryButton.vue?vue&type=template&id=b646f048&"
import script from "./BasePrimaryButton.vue?vue&type=script&lang=js&"
export * from "./BasePrimaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports